import Glide from '@glidejs/glide';
import { getVisibleBullets, getActiveBullet } from '@/utils/glide';

export default function(dom, opts) {
	let options = {
		type: 'slider',
		perView: 4,
		gap: 0,
		keyboard: false,
		breakpoints: {
			1023: {
				perView: 2,
			},
			767: {
				perView: 1,
			}
		},
		swipeThreshold: 80,
		dragThreshold: 120,
		perTouch: 0,
		touchRatio: 0.5,
		touchAngle: 45,
		rewind: false,
		bound: true,
		...opts
	};
	const slides = [].slice.call(dom.querySelectorAll('.glide__slide'), 0);
	const bulletLists = [].slice.call(dom.querySelectorAll('.glide__bullets'), 0);
	const slidesCount = slides.length

	for (let i = 0; i < slidesCount; i++) {
		const glideBullet = document.createElement('button');
		glideBullet.classList.add('glide__bullet');
		glideBullet.dataset.glideDir = `=${i}`;
		bulletLists.forEach(b => b.appendChild(glideBullet.cloneNode(true)));
	}

	if (slidesCount) {
		const glide = new Glide(dom.querySelector('.glide'), options).mount();
		const allBullets = [].slice.call(dom.querySelectorAll('.glide__bullet'), 0);
		let visibleBullets = [];

		const resize = () => {
			visibleBullets = getVisibleBullets(slidesCount, glide.settings.perView);

			if (slidesCount == glide.settings.perView) {
				dom.classList.add('content-slider--hide-bullets');
				glide.go('=0');
			}
			else {
				dom.classList.remove('content-slider--hide-bullets');

				allBullets.forEach(bullet => {
					const index = +(bullet.dataset.glideDir.replace(/=/ig, ''));

					if (visibleBullets.includes(index)) {
						bullet.classList.remove('glide__bullet--hide');
					}
					else {
						bullet.classList.add('glide__bullet--hide');
					}
				});

				if (!visibleBullets.includes(glide.index)) {
					let newIndex = [...visibleBullets].pop();
					glide.go(`=${newIndex}`);
				}
			}
		};

		resize();

		glide.on('resize', resize);
	}
}
